import { render } from "./SubmitSection.vue?vue&type=template&id=6afa0d61&scoped=true"
import script from "./SubmitSection.vue?vue&type=script&lang=js"
export * from "./SubmitSection.vue?vue&type=script&lang=js"

import "./SubmitSection.vue?vue&type=style&index=0&id=6afa0d61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afa0d61"]])

export default __exports__